// PWA install support: captures Chrome/Edge/Samsung `beforeinstallprompt`, detects iOS/standalone.
let deferred = null;
const listeners = new Set();

export function initPwaInstall() {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    listeners.forEach((fn) => fn());
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    localStorage.setItem("tr_app_installed", "1");
    listeners.forEach((fn) => fn());
  });
}

export const onInstallChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const canPromptInstall = () => !!deferred;
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isInstalledHere = () => isStandalone() || localStorage.getItem("tr_app_installed") === "1";
const ua = () => navigator.userAgent || "";
export const isIOS = () => /iPhone|iPad|iPod/i.test(ua()) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isIOSSafari = () => isIOS() && /Safari/i.test(ua()) && !/CriOS|FxiOS|EdgiOS|OPiOS|GSA|Instagram|FBAN|FBAV|LinkedInApp/i.test(ua());
export const isAndroid = () => /Android/i.test(ua());
export const isPhone = () => /iPhone|iPod|Android.+Mobile|Mobile/i.test(ua()) || window.matchMedia?.("(max-width: 640px)").matches;

export async function promptInstall() {
  if (!deferred) return "unavailable";
  deferred.prompt();
  const { outcome } = await deferred.userChoice;
  deferred = null;
  listeners.forEach((fn) => fn());
  return outcome;
}
